export default __webpack_public_path__ + "static/media/the-human-condition.3a34d649.jpg";